__webpack_require__.p = "https://bmidxbpolandplprod.netlify.app/";